import PropTypes from 'prop-types';
import './styles/inputGroupStyles.css';

const InputGroup = ({ children }) => (
  <div className="input-group">{children}</div>
);

InputGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default InputGroup;
